import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import { colors, mediaQueries } from "ui"
import LottiePlayer from "ui/common/bit/LottiePlayer"
import { isLottieFile } from "ui/common/bit/isLottieFile"
import { extractMenuProperties } from "utils"

const StyledText = styled(Typography)`
  max-width: 290px;
  text-align: center;
  ${mediaQueries.desktopXl} {
    line-height: 26px;
  }
  ${mediaQueries.tabletDown} {
    line-height: 18px;
    font-size: 14px;
  }
`

const StyledImageContainerItem = styled(Box)`
  width: 120px;
  height: 130px;
  position: relative;
  margin-bottom: 30px;
  ${mediaQueries.desktopM} {
    margin-bottom: 25px;
  }
  ${mediaQueries.desktop} {
    margin-bottom: 27px;
  }
`

const StyledTitleTypo = styled(Typography)<{ component?: string }>`
  margin-bottom: 12px;
  ${mediaQueries.desktopXl} {
    line-height: 30px;
  }
`

const InnerCardBoxItem = ({ item }: any) => {
  const currImage = extractMenuProperties(item).image
  const currTitle = extractMenuProperties(item).title

  return (
    <>
      {currImage && (
        <StyledImageContainerItem>
          {isLottieFile(currImage) ? (
            <LottiePlayer
              lottieUrl={currImage}
              playOnce={true}
              autoplay={true}
              loop={false}
              ariaLabel={currTitle}
            />
          ) : (
            <Image
              src={currImage}
              alt={currTitle}
              width={120}
              height={130}
              style={{ objectFit: "cover" }}
            />
          )}
        </StyledImageContainerItem>
      )}

      <StyledTitleTypo
        variant="h4"
        component="h3"
        color={colors.black}
        textAlign={"center"}
      >
        {currTitle}
      </StyledTitleTypo>
      <StyledText variant="body2" color={colors.black}>
        {extractMenuProperties(item).text}
      </StyledText>
    </>
  )
}

export default InnerCardBoxItem
